export default "__VITE_ASSET__DlO3wB1___"